import {enableProdMode} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {AppModule} from "./app/app.module";
import {environment} from "./environments/environment";

/*
 * Override console.* methods in order
 * So only ngxlogger can use the default console.* behaviour
 */

export const consoleLog = console.log;
export const consoleInfo = console.info;
export const consoleError = console.error;
export const consoleWarn = console.warn;
export const consoleDebug = console.debug;

if (environment.production) {
	enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule, {
	ngZoneEventCoalescing: true,
});
